<template>
    <div>
        <insurance-coverage
            v-model="has_coverage_proxy"
            :read_only="read_only"
        />

        <insurance-type
            v-if="has_coverage"
            :insurance="insurance"
            :read_only="read_only"
        />

        <insurance-policy
            v-if="has_coverage"
            :insurance="insurance"
            :read_only="read_only"
        />

        <insurance-contact
            v-if="has_coverage"
            :insurance="insurance"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import InsuranceCoverage from './insurance-coverage.vue';
import InsuranceType from './insurance-type.vue';
import InsurancePolicy from './insurance-policy.vue';
import InsuranceContact from './insurance-contact.vue';

export default {
    components: {
        InsuranceCoverage,
        InsuranceType,
        InsurancePolicy,
        InsuranceContact,
    },

    props: {
        insurance: {},
        has_coverage: {},
        read_only: { default: false },
    },

    computed: {
        has_coverage_proxy: {
            get() {
                return this.has_coverage;
            },
            set(value) {
                this.$emit('updateHasCoverage', value);
            },
        }
    },
}
</script>
